import {Button, Card, CardBody, CardHeader, Typography} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {ReferralGrid} from "./grid";
import {getReferrals} from "../../../services/referral/referral";
import {CardFooterPaginator} from "../../system/cardFooterPaginator";
import {ReferralContext} from "../../../context/referral";
import {PaginateContext} from "../../../context/paginate";
import {ReferralForm} from "./form";
import SelectInput from "../../system/select";
import Dict from "../../../helper/dict";
import {getPersonsNameAndFamily} from "../../../services/profile/profile";


export function ReferralManagement() {

  const [referrals, setReferrals] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);

  const [personId, setPersonId] = useState(null)

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getReferrals(paginate);
    if (result.status === 200) {
      const {referralList, total_count} = result.data;
      setReferrals(referralList || []);
      setGridTotalRowCount(total_count);
    }
  }

  const filter = () => {
    const filterParams = {}

    if (personId) {
      filterParams["person_id"] = personId
    }

    return filterParams;
  }

  useEffect(() => {
    // const data = filter()
    const paginateParams = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    })

    const params = filter();
    const filterParams = new URLSearchParams(params);

    for (const [key, value] of filterParams.entries()) {
      paginateParams.append(key, value);
    }

    const paginate = paginateParams.toString()

    getData(paginate)
  }, [personId, gridCurrentPage, gridRowCount, sortBy, sortType, lastDataRefresh]);

  return (
    <ReferralContext.Provider value={{
      referrals: referrals,
      setReferrals: setReferrals,
      referral: gridSelectedRow,
      setReferral: setGridSelectedRow,
      open: modalOpen,
      setOpen: setModalOpen,
      setLastDataRefresh: setLastDataRefresh,
    }}>
      <PaginateContext.Provider value={{
        setSortBy: setSortBy,
        sortType: sortType,
        setSortType: setSortType,
        active: gridCurrentPage,
        setActive: setGridCurrentPage,
        totalRows: gridTotalRowCount,
        rowsCount: gridRowCount,
        setRowsCount: setGridRowCount,
        from: from,
        to: to,
      }}>
        <div className="">

          <ReferralForm/>

          <Card className="pt-8">
            <CardHeader floated={true} shadow={false} className="rounded-none">
              <div className="mb-8 flex items-center justify-between gap-8">
                <Typography variant="h5" color="blue-gray">کدمعرفی نفرات</Typography>
              </div>
            </CardHeader>

            <div className="grid grid-cols-1 gap-2 mb-2 md:grid-cols-2 xxl:grid-cols-3">

              <div className="flex flex-col">
                <SelectInput
                  label={Dict("user")}
                  defaultValue={personId}
                  autoLoadService={getPersonsNameAndFamily}
                  autoLoadRender={({name, family, phone}) => {
                    const fullName = `${name?.trim()} ${family?.trim()}`.trim();
                    return fullName + " - " + phone
                  }}
                  onChange={setPersonId}
                />

              </div>

              <div className="flex flex-col max-w-fit">
                <Button variant="gradient" color="gray" onClick={() => {
                  setPersonId(null)
                }} className="ml-1">
                  <span>حذف فیلتر</span>
                </Button>

              </div>

            </div>

            <CardBody className="overflow-x-auto w-full">
              <ReferralGrid/>
            </CardBody>

            <CardFooterPaginator/>

          </Card>
        </div>
      </PaginateContext.Provider>
    </ReferralContext.Provider>
  );
}